'use es6';

import { reduce } from '../../lib/async';
import { configure as missing } from './missing';
import { configure as count } from './count';
const mutators = [missing, count];
export default (config => {
  return reduce(mutators, (mutated, mutator) => mutator(mutated), config);
});